import '../jquery'

let ready_legacy_domains;

ready_legacy_domains = function () {
  $(document).on("ajax:success", "#new_domain_availability", function (e, data, status, xhr) {
    return $("#domain_availability_page").replaceWith(xhr.responseText);
  }).on("ajax:error", function (e, xhr, status, error) {
    let parent;
    parent = $(e.target).closest(".domain-select");
    parent.siblings(".domain-checking").hide();
    parent.siblings(".domain-error").show();
    return parent.show();
  });
  return $(document).on("click", ".domain-select a", function () {
    let parent;
    parent = $(this).closest(".domain-select");
    parent.hide();
    parent.siblings(".domain-checking").show();
    return parent.siblings(".domain-error").hide();
  });
};

$(document).ready(ready_legacy_domains);

$(document).on('turbo:load', ready_legacy_domains);